import { useAuthState } from "@synthesis/shared-auth";
import { cn } from "@synthesis/shared-utils";

type UserAvatarProps = {
  currentUser?: boolean;
  initials?: string;
  className?: string;
};

const getCurrentUserInitials = (lastName?: string, firstName?: string) =>
  `${lastName?.[0]?.toUpperCase() ?? "-"}${firstName?.[0]?.toUpperCase() ?? "-"}`;

export const UserAvatar = ({ currentUser = false, initials, className }: UserAvatarProps) => {
  const { currentUser: user } = useAuthState();

  const displayInitials = currentUser ? getCurrentUserInitials(user?.lastName, user?.firstName) : initials;

  return (
    <div className={cn("bg-neutrals-90 flex size-8 shrink-0 items-center justify-center rounded-full", className)}>
      <span className="subtitle-sm text-type-minor w-6 text-center">{displayInitials}</span>
    </div>
  );
};
